<section class="sm:min-h-[25.6rem] min-h-[40rem] sm:h-[25.6rem] px-[2rem] py-[1rem] overflow-hidden h-[40rem] sm:w-[51.2rem] w-[61.2rem] flex items-center justify-center bg-white" role="dialog" aria-modal="true" aria-labelledby="session-title">
    <div class="flex flex-col justify-between w-full h-[80%]">
        <mat-dialog-content class="" role="document">
            <div class="!max-h-none !m-0 !p-0 overflow-y-auto flex items-center justify-center text-center h-full">
                <p id="session-title" class="!min-h-fit !m-0 dsr-typescale-body-medium">{{data.message}}</p>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions class="!min-h-fit !m-0 !p-0 flex !font-[600] items-center h-fit justify-center" role="group" aria-label="Session actions">
            <button mat-flat-button class="" (click)="closeDialog('continue')" type="button" aria-label="Continue session">
                <span class=" dsr-typescale-body-small">{{"CONTINUE_BUTTON" | translate}}</span>
            </button>
            <button mat-stroked-button color="primary" (click)="closeDialog('close')" type="button" aria-label="Close session">
                <span class=" dsr-typescale-body-small">{{"CLOSE_BUTTON" | translate}}</span>
            </button>
        </mat-dialog-actions>
    </div>
</section>